// src/components/games/GameHeader.js
function GameHeader({ title }) {
  return (
    <div className="w-full text-white pt-12 pb-2 px-6">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold">{title || "게임명 없음"}</h1>
      </div>
    </div>
  );
}

export default GameHeader;
